import React from 'react';
import ThankYou, { useOnThankYouClick } from './thank-you-form';
import useGiveLinks from './use-give-links';
import CommonElements from './common-elements';
export default function GiveBeforeOther({ link, close, data, track, variant, onDownload, id }) {
    const { showThankYou, onThankYouClick } = useOnThankYouClick();
    const [controlLink] = useGiveLinks();
    const beforeOpen = React.useCallback((e) => {
        close();
        if (onDownload) {
            onDownload(e);
        }
    }, [close, onDownload]);
    if (showThankYou) {
        return (React.createElement(ThankYou, { link: link, close: close, source: variant, itemType: lookupVariant(variant), track: track, id: id }));
    }
    return (React.createElement("div", { className: 'give-before-pdf', "data-analytics-view": true, "data-analytics-nudge": 'donate', "data-nudge-placement": variant },
        React.createElement(CommonElements, { data: data, onThankYouClick: onThankYouClick, giveLink: controlLink }),
        React.createElement("a", Object.assign({ href: link, onClick: beforeOpen, className: 'btn go-to' }, (track ? { 'data-track': track } : {}), { "data-variant": lookupVariant(variant) }),
            "Go to your ",
            lookupVariant(variant))));
}
function lookupVariant(variant) {
    if (variant === 'View online') {
        return 'book';
    }
    if (variant === null || variant === void 0 ? void 0 : variant.includes('resource')) {
        return 'resource';
    }
    return 'item';
}
